<template>
	<v-dialog
		v-model="visible"
		:width="$vuetify.breakpoint.mdAndUp ? '50%' : null"
	>
		<v-card>
			<v-card-title class="headline">{{ command }} Command</v-card-title>
			<v-card-subtitle class="mt-0">
				<template v-if="success">
					<span class="success--text">Success</span>
				</template>
				<template v-else>
					<span class="error--text">Error</span>
				</template>
			</v-card-subtitle>

			<v-card-text>
				<!-- Show JSON response bodies as a key-value list -->
				<v-data-table
					v-if="showTable"
					:headers="headers"
					:items="tableData"
					item-key="name"
					:hide-default-footer="true"
					:disable-filtering="true"
					:disable-pagination="true"
					:disable-sort="true"
					single-expand
					show-expand
				>
					<template #item.value="{ item, value }">
						<template v-if="item.showExpand">
							<em>JSON Object</em>
						</template>
						<template v-else>{{ value }}</template>
					</template>

					<template #item.data-table-expand="{ item, expand, isExpanded }">
						<v-btn v-if="item.showExpand" icon @click="expand(!isExpanded)">
							<v-icon
								>fas {{ isExpanded ? "fa-caret-up" : "fa-caret-down" }}</v-icon
							>
						</v-btn>
					</template>

					<template #expanded-item="{ item }">
						<td colspan="3">
							<pre v-clip class="ma-3 json">{{
								JSON.stringify(item.value, null, 4)
							}}</pre>
						</td>
					</template>
				</v-data-table>

				<!-- Show non-JSON responses verbatim -->
				<span v-else v-clip>
					<span :class="{ 'error--text': !success }">{{
						computedResponse
					}}</span>
					<misc-copy-icon />
				</span>
			</v-card-text>

			<v-card-actions>
				<v-spacer />
				<v-btn color="ocean darken-1" outlined @click="close">Done</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<style lang="scss" scoped>
pre.json {
	font-size: 0.75rem;
}
</style>

<script>
import _ from "lodash";

export default {
	data: () => ({
		visible: false,

		command: null,
		success: false,
		response: null,

		headers: [
			{
				text: "Name",
				align: "start",
				value: "name",
			},
			{
				text: "Value",
				align: "end",
				value: "value",
			},
			{
				text: "",
				align: "end",
				value: "data-table-expand",
			},
		],
	}),

	computed: {
		tableData() {
			return _.transform(
				this.response,
				(accum, value, key) => {
					accum.push({
						name: _.startCase(key),
						value,
						showExpand: _.isObject(value),
					});
					return accum;
				},
				[]
			);
		},

		computedResponse() {
			// Set default error message if none is available
			if (!this.success && _.isEmpty(this.response)) {
				return "Unknown error encountered while executing command";
			}
			return this.response;
		},

		showTable() {
			return _.isObject(this.computedResponse);
		},
	},

	methods: {
		isObject: _.isObject,

		pop({ command, success, response }) {
			this.command = command;
			this.success = success;
			this.response = response;
			this.visible = true;
		},

		async close() {
			this.visible = false;
		},
	},
};
</script>
